export default "__VITE_ASSET__CaAIRKuj__"